import React, { useCallback, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import DashboardAccessBlocked from "./DashboardAccessBlocked";
import {
  fetchDashboardAccess,
  getUsernameForAccessCheck,
  isDashboardAccessBlocked,
} from "../utils/dashboardAccess";

const POLL_INTERVAL_MS = 30000;

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem("token");
  const [accessState, setAccessState] = useState({
    loading: true,
    blocked: false,
    dueDate: null,
  });

  const refreshAccess = useCallback(async () => {
    const username = getUsernameForAccessCheck();
    if (!username) {
      setAccessState({ loading: false, blocked: false, dueDate: null });
      return;
    }

    try {
      const access = await fetchDashboardAccess(username);
      setAccessState({
        loading: false,
        blocked: isDashboardAccessBlocked(access),
        dueDate: access?.billing_due_date || null,
      });
    } catch (error) {
      console.error("Dashboard access check failed:", error);
      setAccessState((current) => ({ ...current, loading: false }));
    }
  }, []);

  useEffect(() => {
    if (!token || token === "undefined") {
      return undefined;
    }

    refreshAccess();
    const intervalId = window.setInterval(refreshAccess, POLL_INTERVAL_MS);
    return () => window.clearInterval(intervalId);
  }, [token, refreshAccess]);

  if (!token || token === "undefined") {
    return <Navigate to="/login" replace />;
  }

  if (accessState.loading) {
    return null;
  }

  if (accessState.blocked) {
    return (
      <DashboardAccessBlocked
        dueDate={accessState.dueDate}
        onRetry={refreshAccess}
      />
    );
  }

  return children;
};

export default PrivateRoute;
